// Pure helpers for the Budget Monitoring pages. ES module without Vue imports so that
// `node --test` (see src/utils/__tests__) and webpack can both load it.

const COLORS = { GREEN: "success", YELLOW: "warning", RED: "error", NO_BUDGET: "grey" };
const LABELS = { GREEN: "HIJAU", YELLOW: "KUNING", RED: "MERAH", NO_BUDGET: "N/A" };
const TINTS = { GREEN: "#E8F5E9", YELLOW: "#FFF8E1", RED: "#FFEBEE", NO_BUDGET: "#EEEEEE" };
const ROW_CLASSES = {
  GREEN: "row-green",
  YELLOW: "row-yellow",
  RED: "row-red",
  NO_BUDGET: "row-none",
};
const METHOD_LABELS = {
  ITEM_EQUAL: "Item sama",
  ITEM_EQUAL_SPLIT: "Item sama (bagi)",
  PANEL_LINK: "Panel code",
  PANEL_LINK_SPLIT: "Panel code (bagi)",
  PROPORTIONAL: "Proporsional",
  NONE: "Tanpa PO",
};
const MARGIN_SOURCE_LABELS = {
  CALC_VERSION: "estimator",
  QUOTE: "quotation",
  OVERRIDE: "override",
  NONE: "tidak ada",
};

export const BANDS = ["GREEN", "YELLOW", "RED", "NO_BUDGET"];
export const BAND_FILTER_ITEMS = [
  { text: "Semua", value: "" },
  { text: "Hijau", value: "GREEN" },
  { text: "Kuning", value: "YELLOW" },
  { text: "Merah", value: "RED" },
  { text: "N/A", value: "NO_BUDGET" },
];
export const NOTIFICATION_TYPES = ["BUDGET_YELLOW", "BUDGET_RED", "BUDGET_RECOVERED"];
export const RECIPIENT_PLACEHOLDERS = ["@PO_SALES", "@ASSIGNED_USER", "@PO_JOB_PIC"];

export const bandColor = b => COLORS[b] || "grey";
export const bandLabel = b => LABELS[b] || "N/A";
export const bandTint = b => TINTS[b] || "#EEEEEE";
export const bandRowClass = b => ROW_CLASSES[b] || "row-none";
export const methodLabel = m => METHOD_LABELS[m] || m || "-";
export const methodColor = m =>
  ["ITEM_EQUAL", "PANEL_LINK"].includes(m) ? "green" : m === "NONE" ? "grey" : "orange";
export const isEstimatedMethod = m => ["ITEM_EQUAL_SPLIT", "PANEL_LINK_SPLIT"].includes(m);
/** A line is an estimate when it was split, or went proportionally to more than one PO (share < 1). */
export const isEstimatedLine = l =>
  !!l && (isEstimatedMethod(l.allocationMethod) || Number(l.allocationShare) < 1);
export const marginSourceLabel = s => MARGIN_SOURCE_LABELS[s] || s || "-";

export const formatIdr = n =>
  n === null || n === undefined || n === ""
    ? "—"
    : Math.round(Number(n))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const formatPct = n =>
  n === null || n === undefined || n === ""
    ? "—"
    : `${Number(n)
        .toFixed(1)
        .replace(".", ",")} %`;

export const formatQty = n => {
  if (n === null || n === undefined || n === "") return "—";
  const v = Number(n);
  return Number.isInteger(v) ? String(v) : String(v).replace(".", ",");
};

export const formatDate = d => {
  if (!d) return "—";
  const s = typeof d === "string" ? d : new Date(d).toISOString();
  return s.substring(0, 10);
};

export const isLowConfidence = (est, threshold) =>
  est !== null && est !== undefined && Number(est) > Number(threshold);

export const sumAmount = lines => (lines || []).reduce((s, l) => s + Number(l.amountIdr || 0), 0);

export const sumBy = (rows, key) =>
  (rows || []).reduce((s, r) => s + Number((r && r[key]) || 0), 0);

export const amountsMatch = (a, b) => Math.abs(Number(a || 0) - Number(b || 0)) < 1;

/** Points for the inline trend svg: ratio in % per snapshot, scaled to a width×height box. */
export const trendPoints = (history, width, height, maxPct = 120) => {
  const rows = (history || []).filter(
    h => h && h.ratioPercent !== null && h.ratioPercent !== undefined
  );
  if (rows.length === 0) return "";
  const step = rows.length === 1 ? 0 : width / (rows.length - 1);
  return rows
    .map((h, i) => {
      const pct = Math.min(Number(h.ratioPercent), maxPct);
      const x = rows.length === 1 ? width / 2 : i * step;
      const y = height - (pct / maxPct) * height;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
};
